import type { QueryColumnSchema } from "../types/dashboard";

export const VISUAL_DRAG_MIME = "application/x-dashboard-visual-type";
export const FIELD_DRAG_MIME = "application/x-dashboard-field";

export type DragFieldPayload = {
  name: string;
  type?: string;
  role?: string;
  queryId?: string;
};

export function encodeDragField(column: QueryColumnSchema, queryId?: string): string {
  return JSON.stringify({
    name: column.name,
    type: column.type,
    role: column.role,
    queryId,
  } satisfies DragFieldPayload);
}

export function decodeDragField(raw: string): DragFieldPayload | null {
  try {
    const parsed = JSON.parse(raw) as DragFieldPayload;
    if (!parsed?.name) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function isDesignerPaletteDrag(types: readonly string[]): boolean {
  return (
    types.includes(VISUAL_DRAG_MIME) ||
    types.includes(FIELD_DRAG_MIME)
  );
}
